import React from 'react';
import styled from 'styled-components';
import Image from 'next/image';

const PurchaseDownloadButton = styled.button`
  border: 1px solid #e5e8f0;
  border-radius: 10px;
  padding: 15px 0px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  div {
    height: 22px;
    width: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  p {
    font-weight: 600;
    font-size: 12px;
    line-height: 140%;
    text-align: center;
    color: #000000;
    margin-top: 5px;
  }
`;

const PurchaseButtonRow = styled.div`
  display: flex;
  grid-gap: 11px;
  align-items: center;
  margin-bottom: 11px;
`;

interface CardLicenseDetailsProps {
  botId: string;
  listingKey: string;
  macDownloadUrl: string;
  windowsDownloadUrl: string;
  dataTour?: string;
}

const CardFooter = (props: CardLicenseDetailsProps): JSX.Element => {
  const onDownloadWin = () => {
    let downloadUrl = props.windowsDownloadUrl;
    if (props.listingKey && props.botId === 'stellar') {
      downloadUrl += `?key=${props.listingKey}`;
    }
    window.open(downloadUrl, '_blank', 'noopener');
  };

  const onDownloadMac = () => {
    let downloadUrl = props.macDownloadUrl;
    if (props.listingKey && props.botId === 'stellar') {
      downloadUrl += `?key=${props.listingKey}`;
    }
    window.open(downloadUrl, '_blank', 'noopener');
  };

  return (
    <>
      <PurchaseButtonRow data-tour={props.dataTour}>
        {props.windowsDownloadUrl && props.windowsDownloadUrl.length > 0 && (
          <PurchaseDownloadButton onClick={onDownloadWin}>
            <div>
              <Image
                alt=""
                src={'/images/new/windows_black.svg'}
                layout="fill"
              />
            </div>
            <p>Download windows</p>
          </PurchaseDownloadButton>
        )}
        {props.macDownloadUrl && props.macDownloadUrl.length > 0 && (
          <PurchaseDownloadButton onClick={onDownloadMac}>
            <div>
              <Image alt="" src={'/images/new/apple_black.svg'} layout="fill" />
            </div>
            <p>Download MacOS</p>
          </PurchaseDownloadButton>
        )}
      </PurchaseButtonRow>
    </>
  );
};

export default CardFooter;
